(() => {
  const $ = (id) => document.getElementById(id);

  const dataEl = $("catterpod-data");
  const previewEl = $("cp-preview");
  const canvasEl = $("cp-canvas");

  const addFloatBtn = $("cp-add-float");
  const addToCartBtn = $("cp-add-to-cart");
  const popType = $("cp-popover-type");
  const popColor = $("cp-popover-color");
  const typeOptionsEl = $("cp-type-options");
  const typeHintEl = $("cp-type-hint");
  const colorOptionsEl = $("cp-color-options");
  const colorHintEl = $("cp-color-hint");
  const colorBackBtn = $("cp-color-back");
  const colorAddBtn = $("cp-color-add");

  const statusEl = $("cp-status");
  const heightEl = $("cp-height");
  const priceEl = $("cp-price");
  const breakdownListEl = $("cp-breakdown-list");

  const setStatus = (msg) => {
    if (statusEl) statusEl.textContent = msg || "";
    if (msg) console.warn(msg);
  };

  if (!dataEl || !previewEl || !canvasEl || !addFloatBtn || !popType || !popColor) return;

  let DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error(e);
    return setStatus("Configurator JSON invalid. Check Liquid output.");
  }
  const MAX_HEIGHT_CM = Number(DATA.max_height_cm || 365.76);
  const NEAR_MAX_CM = Number(DATA.near_max_cm || 20);
  const BRACKET_BOUNDARIES_CM = [94, 144, 219, 294];
  const CURRENCY = String(DATA.currency || "USD");
  const PREORDER_ENABLED = Boolean(DATA.preorder_enabled);
  const PREORDER_STATUS = String(DATA.preorder_status || "");
  const PREORDER_BATCH_LABEL = String(DATA.preorder_batch_label || "");
  const PREORDER_DISPATCH_TEXT = String(DATA.preorder_dispatch_text || "");

  const normType = (t) => String(t || "").trim().toLowerCase().replace(/\s+/g, "_");
  const normMat = (m) => String(m || "").trim().toLowerCase().replace(/\s+/g, "_");

  // Physical component widths used by the auto-scaled preview.
  const MODULE_WIDTH_CM = {
    base: 40,
    pod: 37,
    large_spacer: 37,
    small_spacer: 37,
    nest: 37
  };

  // Parse "35,00", "35.00", "3500" safely
  function parsePrice(raw) {
    if (raw == null) return 0;
    let s = String(raw).trim();
    if (!s) return 0;

    // keep digits and separators only
    s = s.replace(/[^\d.,-]/g, "");

    const hasComma = s.includes(",");
    const hasDot = s.includes(".");

    if (hasComma && hasDot) {
      // decide decimal by last separator
      const lastComma = s.lastIndexOf(",");
      const lastDot = s.lastIndexOf(".");
      if (lastComma > lastDot) {
        // comma decimal, dots thousands
        s = s.replace(/\./g, "").replace(",", ".");
      } else {
        // dot decimal, commas thousands
        s = s.replace(/,/g, "");
      }
    } else if (hasComma && !hasDot) {
      // assume comma is decimal
      s = s.replace(",", ".");
    } else {
      // remove thousands commas
      s = s.replace(/,/g, "");
    }

    let n = Number(s);
    if (!Number.isFinite(n)) n = 0;

    // IMPORTANT FIX:
    // If Shopify stored "35.00" as "3500" (common when comma is used in entry),
    // treat large integers as cents.
    if (Number.isInteger(n) && n >= 1000) {
      n = n / 100;
    }

    return n;
  }

  // Build catalog: catalog[type][material] = component
  const catalog = {};
  let bracketComponent = null;

  for (const c of (DATA.components || [])) {
    if (!c || !c.enabled) continue;

    const type = normType(c.module_type);
    const mat = normMat(c.material);

    const record = {
      ...c,
      module_type: type,
      material: mat,
      height_cm: Number(c.height_cm || 0),
      price_amount: parsePrice(c.price_amount_raw)
    };

    if (type === "bracket") {
      if (!bracketComponent) bracketComponent = record;
      continue;
    }

    if (!catalog[type]) catalog[type] = {};
    catalog[type][mat] = record;
  }

  const materialsForType = (type) => Object.keys(catalog[normType(type)] || {});
  const defaultMaterialForType = (type) => {
    const mats = materialsForType(type);
    for (const m of ["cloud", "storm", "dune", "black"]) if (mats.includes(m)) return m;
    return mats[0] || null;
  };

  const getComp = (item) => catalog[normType(item.type)]?.[normMat(item.material)] || null;

  const cmToIn = (cm) => cm / 2.54;

  const state = {
    units: "ftin",
    stack: [{ id: "base-0", type: "base", material: "black" }],
    pop: { open: false, step: "type", selectedType: null, selectedMaterial: null }
  };
  const cartQtyByVariant = new Map();

  async function loadCartQuantities() {
    try {
      const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      if (!res.ok) return;
      const cart = await res.json();
      cartQtyByVariant.clear();
      for (const item of (cart.items || [])) {
        const id = Number(item.variant_id || item.id || 0);
        if (!id) continue;
        cartQtyByVariant.set(id, (cartQtyByVariant.get(id) || 0) + Number(item.quantity || 0));
      }
    } catch (e) {
      console.warn("Could not load cart quantities", e);
    }
  }

  function normalizeStack() {
    // Ensure exactly one base at bottom
    state.stack = state.stack.filter(x => normType(x.type) !== "base");
    state.stack.unshift({ id: "base-0", type: "base", material: "black" });

    // Ensure max 1 nest and nest must be top
    let nestSeen = false;
    state.stack = state.stack.filter(x => {
      if (normType(x.type) !== "nest") return true;
      if (nestSeen) return false;
      nestSeen = true;
      return true;
    });

    const ni = state.stack.findIndex(x => normType(x.type) === "nest");
    if (ni !== -1 && ni !== state.stack.length - 1) {
      const nest = state.stack.splice(ni, 1)[0];
      state.stack.push(nest);
    }
  }

  function totalHeightCm() {
    let sum = 0;
    for (const item of state.stack) {
      const c = getComp(item);
      if (!c) continue;
      sum += Number(c.height_cm || 0);
    }
    return sum;
  }

  function selectedQtyForVariant(variantId) {
    const id = Number(variantId || 0);
    if (!id) return 0;
    let qty = 0;
    for (const it of state.stack) {
      const comp = getComp(it);
      if (!comp || Number(comp.variant_id || 0) !== id) continue;
      qty += 1;
    }
    return qty;
  }

  function availableToAdd(comp, desiredQty = 1) {
    if (!comp || !comp.variant_id) return false;
    const policy = String(comp.inventory_policy || "").toLowerCase();
    if (policy === "continue") return true;

    const rawStock = comp.inventory_quantity;
    const stock = Number(rawStock);
    const inCart = cartQtyByVariant.get(Number(comp.variant_id)) || 0;
    const inBuild = selectedQtyForVariant(comp.variant_id);
    if (rawStock == null || !Number.isFinite(stock)) {
      return Boolean(comp.variant_available);
    }
    if (stock === 0 && comp.variant_available) {
      return true;
    }
    return stock - inCart - inBuild >= Number(desiredQty || 1);
  }

  function hasCartCapacity(comp, requiredQty = 1) {
    if (!comp || !comp.variant_id) return false;
    const policy = String(comp.inventory_policy || "").toLowerCase();
    if (policy === "continue") return true;

    const rawStock = comp.inventory_quantity;
    const stock = Number(rawStock);
    const inCart = cartQtyByVariant.get(Number(comp.variant_id)) || 0;
    if (rawStock == null || !Number.isFinite(stock)) {
      return Boolean(comp.variant_available);
    }
    if (stock === 0 && comp.variant_available) {
      return true;
    }
    return stock - inCart >= Number(requiredQty || 1);
  }

  // Exact boundaries use the higher tier, through the 12 ft cap.
  function bracketCountForHeightCm(heightCm) {
    const h = Number(heightCm || 0);
    return BRACKET_BOUNDARIES_CM.filter(boundary => h >= boundary).length;
  }

  function canAddType(type) {
    const t = normType(type);

    const hasNest = state.stack.some(x => normType(x.type) === "nest");
    if (hasNest) return { ok: false, reason: "Nest is the top component." };

    const mats = materialsForType(t);
    if (!mats.length) return { ok: false, reason: "Not available." };

    const hasFit = mats.some((m) => {
      const comp = catalog[t]?.[m];
      if (!comp) return false;
      const nextHeight = totalHeightCm() + Number(comp.height_cm || 0);
      return nextHeight <= MAX_HEIGHT_CM;
    });
    if (!hasFit) return { ok: false, reason: "Exceeds max height." };

    const hasStock = mats.some((m) => availableToAdd(catalog[t]?.[m], 1));
    if (!hasStock) return { ok: false, reason: "Out of stock." };

    return { ok: true, reason: "" };
  }

  function pxPerCmFixed() {
    return Math.min((previewEl.clientHeight - 64) / Math.max(totalHeightCm(), 80), (previewEl.clientWidth - 100) / 40);
  }

  function formatMoney(amount) {
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: CURRENCY }).format(amount);
    } catch {
      return `$${amount.toFixed(2)}`;
    }
  }

  function computeTotals() {
    let componentsTotal = 0;
    for (const item of state.stack) {
      const c = getComp(item);
      if (!c) continue;
      componentsTotal += Number(c.price_amount || 0);
    }

    const h = totalHeightCm();
    const bracketQty = bracketComponent ? bracketCountForHeightCm(h) : 0;
    const bracketUnit = bracketComponent ? Number(bracketComponent.price_amount || 0) : 0;
    const bracketsTotal = bracketQty * bracketUnit;

    return { grandTotal: componentsTotal + bracketsTotal };
  }

  function renderHeight() {
    const cm = totalHeightCm();
    const roundedInches = Math.ceil(cmToIn(cm));
    const maxRoundedInches = Math.ceil(cmToIn(MAX_HEIGHT_CM));
    const feet = Math.floor(roundedInches / 12);
    const inches = roundedInches % 12;
    const maxFeet = Math.floor(maxRoundedInches / 12);
    const maxInches = maxRoundedInches % 12;
    const near = MAX_HEIGHT_CM - cm <= NEAR_MAX_CM;

    heightEl.textContent =
      state.units === "cm"
        ? `${cm.toFixed(1)} cm (max ${MAX_HEIGHT_CM} cm)`
        : `${feet} ft ${inches} in (max ${maxFeet} ft ${maxInches} in)`;

    heightEl.classList.toggle("is-near-max", !!near);
  }

  function renderPrice() {
    const t = computeTotals();
    priceEl.textContent = formatMoney(t.grandTotal);
    const giftStatus = $("cp-gift-status");
    if (giftStatus) giftStatus.textContent = t.grandTotal > 200
      ? "Your build qualifies for one free Scratch Shield. Choose Pod or Large Spacer in your cart. Founders Preorder only; one per custom build over $200 USD before discounts and tax."
      : "One free Scratch Shield per custom build over $200 USD before discounts and tax during the Founders Preorder. Choose your version in the cart.";
  }

  function prettyType(t) {
    const type = normType(t);
    if (type === "large_spacer") return "Large Spacer";
    if (type === "small_spacer") return "Small Spacer";
    return type.charAt(0).toUpperCase() + type.slice(1);
  }

  function prettyColor(c, type) {
    if (normType(type) === "bracket") return "Silver";
    const color = String(c || "").trim();
    if (!color) return "Unknown";
    return color.charAt(0).toUpperCase() + color.slice(1).toLowerCase();
  }

  function getBuildCounts(stack, bracketQty = 0) {
    const counts = new Map();
    for (const it of stack) {
      const type = normType(it.type);
      const color = normMat(it.material);
      const key = `${type}__${color}`;
      counts.set(key, (counts.get(key) || 0) + 1);
    }

    if (Number(bracketQty) > 0) {
      counts.set("bracket__silver", Number(bracketQty));
    }

    return counts;
  }

  function sortCountEntries(counts) {
    const entries = Array.from(counts.entries());
    entries.sort(([a], [b]) => {
      const [typeA] = a.split("__");
      const [typeB] = b.split("__");
      if (typeA === "base") return -1;
      if (typeB === "base") return 1;
      if (typeA === "nest") return 1;
      if (typeB === "nest") return -1;
      if (typeA === "bracket") return 1;
      if (typeB === "bracket") return -1;
      return a.localeCompare(b);
    });
    return entries;
  }

  function renderBreakdown() {
    if (!breakdownListEl) return;

    const bracketQty = bracketCountForHeightCm(totalHeightCm());
    const counts = getBuildCounts(state.stack, bracketQty);
    breakdownListEl.innerHTML = "";

    for (const [key, qty] of sortCountEntries(counts)) {
      const [type, color] = key.split("__");
      const line = document.createElement("li");
      line.textContent = `${prettyType(type)} - ${prettyColor(color, type)} x${qty}`;
      breakdownListEl.appendChild(line);
    }
  }

  function closePopovers() {
    state.pop.open = false;
    state.pop.step = "type";
    state.pop.selectedType = null;
    state.pop.selectedMaterial = null;

    popType.setAttribute("aria-hidden", "true");
    popColor.setAttribute("aria-hidden", "true");
    popType.classList.remove("is-open");
    popColor.classList.remove("is-open");
  }

  function openTypePopover() {
    state.pop.open = true;
    state.pop.step = "type";

    popColor.setAttribute("aria-hidden", "true");
    popColor.classList.remove("is-open");

    popType.setAttribute("aria-hidden", "false");
    popType.classList.add("is-open");
  }

  function openColorPopover(type) {
    state.pop.open = true;
    state.pop.step = "color";
    state.pop.selectedType = normType(type);
    state.pop.selectedMaterial = defaultMaterialForType(type);

    popType.setAttribute("aria-hidden", "true");
    popType.classList.remove("is-open");

    popColor.setAttribute("aria-hidden", "false");
    popColor.classList.add("is-open");
  }

  // Add button position: above top stack
  function updateAddButtonPosition() {
    const pxcm = pxPerCmFixed();
    const hPx = totalHeightCm() * pxcm;

    const pad = 12;
    const btnH = 42;
    const y = previewEl.clientHeight - hPx - btnH - 10;
    const clamped = Math.max(pad, Math.min(previewEl.clientHeight - btnH - pad, y));

    addFloatBtn.style.top = `${clamped}px`;

    const hasNest = state.stack.some(x => normType(x.type) === "nest");
    addFloatBtn.style.display = hasNest ? "none" : "flex";

    if (hasNest) closePopovers();
  }

  async function renderPreview() {
    canvasEl.innerHTML = "";
    canvasEl.style.position = "absolute";
    canvasEl.style.inset = "0";

    const pxcm = pxPerCmFixed();
    let bottomPx = 0;

    for (const item of state.stack) {
      const c = getComp(item);
      if (!c || !c.png_url) continue;

      const typeKey = normType(item.type);

      const hPx = Number(c.height_cm || 0) * pxcm;
      const wCm = MODULE_WIDTH_CM[typeKey] ?? 37;
      const wPx = wCm * pxcm;

      const wrap = document.createElement("div");
      wrap.className = "cp-module";
      wrap.style.bottom = `${bottomPx}px`;
      wrap.style.height = `${hPx}px`;
      wrap.style.width = `${wPx}px`;

      const img = new Image();
      img.src = c.png_url;
      img.alt = `${c.module_type} ${c.material}`;

      img.style.setProperty("width", `${wPx}px`, "important");
      img.style.setProperty("height", `${hPx}px`, "important");
      img.style.setProperty("max-width", "none", "important");
      img.style.setProperty("display", "block", "important");

      wrap.appendChild(img);

      if (typeKey !== "base") {
        const rm = document.createElement("button");
        rm.type = "button";
        rm.className = "cp-removeBtn";
        rm.textContent = "×";
        rm.setAttribute("aria-label", `Remove ${c.material} ${c.module_type}`);
        rm.addEventListener("click", (e) => {
          e.stopPropagation();
          state.stack = state.stack.filter(x => x.id !== item.id);
          normalizeStack();
          refresh();
        });
        wrap.appendChild(rm);
      }

      canvasEl.appendChild(wrap);
      bottomPx += hPx;
    }
  }

  function renderTypeOptions() {
    const types = [
      { key: "pod", label: "Pod" },
      { key: "large_spacer", label: "Large Spacer" },
      { key: "small_spacer", label: "Small Spacer" },
      { key: "nest", label: "Nest" }
    ];

    typeOptionsEl.innerHTML = "";
    typeHintEl.textContent = "";

    for (const t of types) {
      const res = canAddType(t.key);

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cp-optionBtn";
      btn.textContent = t.label;
      btn.disabled = !res.ok;
      btn.title = res.ok ? "" : (res.reason || "Not available");

      btn.addEventListener("click", () => {
        if (!res.ok) return;
        openColorPopover(t.key);
        renderColorOptions(t.key);
      });

      typeOptionsEl.appendChild(btn);
      if (t.key === "nest") {
        const note = document.createElement("small");
        note.id = "cp-nest-option-note";
        note.className = "cp-optionNote";
        note.textContent = "Top component — nothing can be added above it.";
        btn.setAttribute("aria-describedby", note.id);
        typeOptionsEl.appendChild(note);
      }
    }
  }

  function renderColorOptions(type) {
    const t = normType(type);
    const mats = materialsForType(t);

    colorOptionsEl.innerHTML = "";
    colorHintEl.textContent = "";

    if (!mats.length) {
      colorHintEl.textContent = "No colors available.";
      colorAddBtn.disabled = true;
      return;
    }

    let selected = state.pop.selectedMaterial || mats[0];
    const availableMats = mats.filter((m) => {
      const comp = catalog[t]?.[m];
      if (!comp) return false;
      return availableToAdd(comp, 1);
    });
    if (availableMats.length) {
      selected = availableMats.includes(selected) ? selected : availableMats[0];
      state.pop.selectedMaterial = selected;
    }

    mats.forEach((m) => {
      const comp = catalog[t]?.[m];
      const inStock = availableToAdd(comp, 1);
      const b = document.createElement("button");
      b.type = "button";
      b.className = "cp-optionBtn";
      b.textContent = m.charAt(0).toUpperCase() + m.slice(1);
      b.classList.toggle("is-selected", m === selected);
      b.disabled = !inStock;
      b.title = inStock ? "" : "Out of stock";

      b.addEventListener("click", () => {
        if (!inStock) return;
        selected = m;
        state.pop.selectedMaterial = m;
        [...colorOptionsEl.querySelectorAll(".cp-optionBtn")].forEach(x => x.classList.remove("is-selected"));
        b.classList.add("is-selected");
      });

      colorOptionsEl.appendChild(b);
    });

    colorAddBtn.disabled = !availableMats.length;
    if (!availableMats.length) {
      colorHintEl.textContent = "No colors in stock.";
    }

    colorAddBtn.onclick = () => {
      const addType = state.pop.selectedType;
      const addMat = state.pop.selectedMaterial || defaultMaterialForType(addType);
      if (!addType || !addMat) return;

      const comp = catalog[addType]?.[addMat];
      if (!comp) return;
      if (!availableToAdd(comp, 1)) {
        colorHintEl.textContent = "That color is out of stock.";
        return;
      }

      const nextH = totalHeightCm() + Number(comp.height_cm || 0);
      if (nextH > MAX_HEIGHT_CM) {
        colorHintEl.textContent = "That won’t fit within max height.";
        return;
      }

      state.stack.push({ id: `${addType}-${crypto.randomUUID()}`, type: addType, material: addMat });
      closePopovers();
      refresh();
    };
  }

  async function refresh() {
    try {
      setStatus("");
      normalizeStack();
      renderHeight();
      renderPrice();
      renderBreakdown();
      updateAddButtonPosition();
      await renderPreview();
    } catch (e) {
      console.error(e);
      setStatus(e.message || "Unknown error");
    }
  }

  // ===== Add to Cart (Bundle) =====
  const BRACKET_VARIANT_ID = 48714573775090;

  function bracketQtyForHeight(heightCm) {
    const h = Number(heightCm || 0);
    return BRACKET_BOUNDARIES_CM.filter(boundary => h >= boundary).length;
  }

  // Build a nice summary used in cart bundle card
  function buildBundleSummary(stack, bracketQty) {
    const counts = getBuildCounts(stack, bracketQty);
    const lines = [];
    for (const [k, qty] of sortCountEntries(counts)) {
      const [type, color] = k.split("__");
      lines.push(`${prettyType(type)} - ${prettyColor(color, type)} x${qty}`);
    }

    return lines.join(" | ");
  }

  async function ajaxAddToCart(items) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items })
    });
    if (!res.ok) {
      let parsed;
      let txt = "";
      try {
        parsed = await res.json();
      } catch {
        txt = await res.text();
      }
      const msg = parsed?.description || parsed?.message || txt || "Cart Error";
      if (res.status === 422) {
        throw new Error(`Unable to add build. A component hit its stock/cart limit. ${msg}`);
      }
      throw new Error(`Add to cart failed: ${msg}`);
    }
    return res.json();
  }

  addToCartBtn?.addEventListener("click", async () => {
    try {
      setStatus("");

      normalizeStack();

      // Validate base mapping (base must be black)
      const baseComp = getComp({ type: "base", material: "black" });
      if (!baseComp || !baseComp.variant_id) {
        throw new Error("Base (black) variant is missing. Check metaobject mappings.");
      }

      if (!state.stack.some(item => normType(item.type) === "nest")) {
        const prompt = $("cp-nest-reminder");
        if (prompt && prompt.dataset.confirmed !== "true") {
          prompt.hidden = false;
          $("cp-continue-without-nest")?.focus();
          return;
        }
        if (prompt) { prompt.hidden = true; delete prompt.dataset.confirmed; }
      }

      // Bundle id for grouping in cart
      const bundleId = crypto.randomUUID();
      const bundleTitle = "Catterpod Custom Build";

      const heightCm = totalHeightCm();
      const bracketQty = bracketQtyForHeight(heightCm);

      const summary = buildBundleSummary(state.stack, bracketQty);

      // Build component items array
      const items = [];
      const missing = [];
      for (const it of state.stack) {
        const comp = getComp(it);
        if (!comp || !comp.variant_id) {
          console.warn("Missing variant mapping for", it);
          missing.push(it);
          continue;
        }

        items.push({
          id: Number(comp.variant_id),
          quantity: 1,
          properties: {
            _cp_bundle_id: bundleId,
            _cp_bundle_title: bundleTitle,
            _cp_type: normType(it.type),
            _cp_color: normMat(it.material),
            _cp_summary: summary,
            _cp_hide_in_cart: "1"
          }
        });

        if (PREORDER_ENABLED && PREORDER_STATUS === "open") {
          items[items.length - 1].properties._cp_preorder = "1";
          items[items.length - 1].properties._cp_preorder_batch = PREORDER_BATCH_LABEL;
          items[items.length - 1].properties._cp_preorder_dispatch = PREORDER_DISPATCH_TEXT;
        }
      }

      if (missing.length) {
        const list = missing
          .map((it) => `${prettyType(it.type)} — ${normMat(it.material)}`)
          .join(", ");
        throw new Error(`Missing variant mapping for: ${list}`);
      }

      const requiredByVariant = new Map();
      for (const item of items) {
        const id = Number(item.id);
        requiredByVariant.set(id, (requiredByVariant.get(id) || 0) + Number(item.quantity || 0));
      }

      const stockIssues = [];
      for (const [variantId, requiredQty] of requiredByVariant.entries()) {
        const comp = (DATA.components || []).find((c) => Number(c.variant_id) === Number(variantId));
        if (!hasCartCapacity(comp, requiredQty)) {
          const type = comp?.module_type || "Component";
          const color = comp?.material || "";
          stockIssues.push(`${prettyType(type)} - ${prettyColor(color, type)}`);
        }
      }
      if (stockIssues.length) {
        throw new Error(`Out of stock for: ${stockIssues.join(", ")}`);
      }

      if (!items.length) {
        throw new Error("No items available to add. Check component variant mappings.");
      }

      // Add brackets as hidden line items, linked to this bundle id
      if (bracketQty > 0) {
        items.push({
          id: Number(BRACKET_VARIANT_ID),
          quantity: bracketQty,
          properties: {
            _cp_bundle_id: bundleId,
            _cp_bundle_title: bundleTitle,
            _cp_is_bracket: "1",
            _cp_type: "bracket",
            _cp_color: "silver",
            _cp_summary: summary,
            _cp_hide_in_cart: "1"
          }
        });

        if (PREORDER_ENABLED && PREORDER_STATUS === "open") {
          items[items.length - 1].properties._cp_preorder = "1";
          items[items.length - 1].properties._cp_preorder_batch = PREORDER_BATCH_LABEL;
          items[items.length - 1].properties._cp_preorder_dispatch = PREORDER_DISPATCH_TEXT;
        }
      }

      await ajaxAddToCart(items);

      // Go to cart page
      window.location.href = "/cart";
    } catch (e) {
      console.error(e);
      setStatus(e.message || "Add to cart failed.");
    }
  });

  $("cp-continue-without-nest")?.addEventListener("click", () => {
    $("cp-nest-reminder").dataset.confirmed = "true";
    addToCartBtn.click();
  });
  $("cp-edit-build")?.addEventListener("click", () => {
    $("cp-nest-reminder").hidden = true;
    addFloatBtn.focus();
  });

  // Events
  addFloatBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    if (state.pop.open) closePopovers();
    else {
      openTypePopover();
      renderTypeOptions();
    }
  });

  colorBackBtn.addEventListener("click", () => {
    openTypePopover();
    renderTypeOptions();
  });

  document.addEventListener("click", (e) => {
    if (!state.pop.open) return;
    if (!previewEl.contains(e.target)) closePopovers();
  });

  document.querySelectorAll(".cp-unit").forEach((b) => {
    b.addEventListener("click", () => {
      document.querySelectorAll(".cp-unit").forEach(x => x.classList.remove("is-active"));
      b.classList.add("is-active");
      state.units = b.dataset.unit;
      renderHeight();
    });
  });

  window.addEventListener("resize", () => refresh());

  loadCartQuantities().finally(() => refresh());
})();
